import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getCompositeId } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { DeviationResourceType } from '@wix/da-shared-react/pkg/types/deviation';
import { selectors } from '@wix/da-shared-react/pkg/Stream';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { getModuleData } from '../../../selectors/modules';
import {
  getSelectedTierId,
  getSelectedTierContentType,
} from '../../../selectors/subscriptionsSection';
import { setSelectedTierContentType } from '../../../actions/subscriptionsSection';
import { SubscriptionsTierContentType } from '../../../../types/subscriptionsSection';
import { Props } from './TierContent';

type StateProps = Pick<
  Props,
  | 'tier'
  | 'selectedTierContentType'
  | 'isOwner'
  | 'isEmpty'
  | 'streamId'
  | 'profileOwner'
>;
type DispatchProps = Pick<Props, 'setSelectedTierContentType'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const selectedTierId = getSelectedTierId(state);
  const { streamId } = getModuleData(state, ownProps.moduleId);
  const tier =
    selectedTierId &&
    getDeviationById(
      state,
      getCompositeId(DeviationResourceType.TIER, selectedTierId)
    );
  return {
    tier: tier || undefined,
    isOwner: isCurrentUserProfileOwner(state),
    profileOwner: getProfileOwnerUser(state),
    streamId,
    isEmpty: (selectors.getItems(state, streamId) || []).length === 0,
    selectedTierContentType:
      getSelectedTierContentType(state) ||
      SubscriptionsTierContentType.DEVIATIONS,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedTierContentType,
};

export default connect(mapStateToProps, mapDispatchToProps);
